import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { motion } from "framer-motion";
import { FiRefreshCw } from "react-icons/fi";

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { user, tenant, loading, isSystemAdmin } = useAuth();
  const location = useLocation();

  // Show loading spinner while checking auth
  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black flex items-center justify-center">
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
          className="text-blue-400 text-4xl"
        >
          <FiRefreshCw />
        </motion.div>
        <span className="ml-4 text-white text-lg">Checking authentication...</span>
      </div>
    );
  }

  // NOT LOGGED IN - Redirect to login
  if (!user) {
    console.log("ProtectedRoute: No user found, redirecting to login");
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // REQUIRES ADMIN but user is not admin
  if (requireAdmin && !isSystemAdmin) {
    console.log("ProtectedRoute: Admin required but user is not admin");
    return <Navigate to="/dashboard" replace />;
  }

  // TENANT IS SUSPENDED (for non-admin routes)
  if (!requireAdmin && tenant?.status === "suspended") {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black flex items-center justify-center p-4">
        <div className="bg-gray-800/50 border border-red-500/50 rounded-xl p-8 max-w-md text-center">
          <div className="text-red-400 text-5xl mb-4">⚠️</div>
          <h1 className="text-2xl font-bold text-white mb-2">
            Account Suspended
          </h1>
          <p className="text-gray-400 mb-4">
            Your company account has been suspended. Please contact support for
            assistance.
          </p>
          <p className="text-gray-500 text-sm">
            Tenant: {tenant?.name || "Unknown"}
          </p>
        </div>
      </div>
    );
  }

  // User is authenticated - render the protected content
  console.log("ProtectedRoute: User authenticated, rendering content");
  return children;
};

export default ProtectedRoute;
